import React from 'react';
import { ButtonGroup, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAuth } from '../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { isHosterOrAbove } from '../utils/roles';

const Control = ({ selectedRows, onDelete, onAssignTag }) => {
  const theme = useTheme();
  const { user } = useAuth();
  const { t } = useTranslation('admin');

  // Control доступен только для хостера и админа/супер-админа
  const canControl = isHosterOrAbove(user?.role);

  if (!selectedRows || selectedRows.length === 0 || !canControl) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 'auto',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1300,
        width: 'fit-content',
        height: 'fit-content',
        padding: '10px',
      }}
    >
      <ButtonGroup 
        variant="contained" 
        color="primary"
      >
        <Button 
          onClick={onDelete}
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.mode === 'dark' ? '#000' : '#fff',
          }}
        >
          {t('common:delete')}
        </Button>

        <Button
          onClick={onAssignTag}
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.mode === 'dark' ? '#000' : '#fff',
          }}
        >
          {t('controlAssignTag')}
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default Control;


